import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const usePatientsStore = defineStore({
    id: 'patients',
    state: () => ({
        headerList: ['T.H.E Check Up Centre', 'Check Up Serices', 'Vaccinations', 'Telemedicines', 'Emergency Assistance', 'Nursing Services'],
        eggDescList: [
            {
                eggIconObj: { componentName: 'patients', imgName: 'secure', imgFormat: 'svg', width: '4.6vw' },
                label: 'patients.safe'
            },
            {
                eggIconObj: { componentName: 'patients', imgName: 'todo', imgFormat: 'svg', width: '4.6vw' },
                label: 'patients.prioritized'
            },
            {
                eggIconObj: { componentName: 'patients', imgName: 'user', imgFormat: 'svg', width: '4.6vw' },
                label: 'patients.individualized'
            }
        ],
        photoDescList: [
            {
                id: 'healthoptim',
                label: 'patients.healthOptim',
                description: 'patients.healthOptimDesc',
                image: { componentName: 'patients', imgName: 'healthOptim', imgFormat: 'svg' },
            },
            {
                id: 'diseaseman',
                label: 'patients.diseaseMan',
                description: 'patients.diseaseManDesc',
                image: { componentName: 'patients', imgName: 'diseaseMan', imgFormat: 'svg' },
            },
            {
                id: 'doctorref',
                label: 'patients.doctorRef',
                description: 'patients.doctorRefDesc',
                image: { componentName: 'patients', imgName: 'doctorRef', imgFormat: 'svg' },
            },
            {
                id: 'homecare',
                label: 'patients.homeCare',
                description: 'patients.homeCareDesc',
                image: { componentName: 'patients', imgName: 'takeCare', imgFormat: 'svg' },
            },
        ]
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePatientsStore, import.meta.hot));
}

export { usePatientsStore };
